import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/appearance.css';
import { applyAppearance, readStoredAppearance } from './theme/appearance';
import { applyTheme, readStoredTheme } from './theme/theme';
import App from './App';
import './theme/light-theme.css';
import reportWebVitals from './reportWebVitals';

applyTheme(readStoredTheme());
applyAppearance(readStoredAppearance());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
